module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-5.140941cf.png";